import { Center, Flex, Spacer, Text } from "@chakra-ui/react";
import { AppIcon } from "./AppIcon";

interface AppStatasticCardProps {
    text1?: string;
    text2?: string;
    text3?: string;
    text4?: string;
    text5?: string;
    iconName?: string;
}

export const AppStatasticCard = ({
    text1 = "",
    text2 = "",
    text3 = "",
    text4 = "",
    text5 = "",
    iconName = "",
}: AppStatasticCardProps) => {
    return (
        <Flex
            h={"143px"}
            direction={"column"}
            p={"1.25rem"}
            border={"1px solid var(--chakra-colors-greyT90)"}
            borderRadius={"4px"}
            bg={"var(--chakra-colors-white)"}
            justifyContent={"space-between"}
        >
            <Flex alignItems={"center"}>
                {iconName && (
                    <Center
                        w={"35px"}
                        h={"35px"}
                        bg={"var(--chakra-colors-greyT95)"}
                    >
                        <AppIcon name={iconName} w="1.4rem" />
                    </Center>
                )}
                <Spacer />
                <Text textStyle={"mediumXl"}>{text1}</Text>
            </Flex>
            <Flex justifyContent={"space-between"}>
                <Flex direction={"column"} gap={1}>
                    <Text
                        textStyle={"regularSm"}
                        color={"var(--chakra-colors-contentT40)"}
                    >
                        {text2}
                    </Text>
                    <Text textStyle={"semiBoldXl"}>{text3}</Text>
                </Flex>
                <Flex direction={"column"} gap={1}>
                    <Text
                        textStyle={"regularSm"}
                        color={"var(--chakra-colors-contentT40)"}
                    >
                        {text4}
                    </Text>
                    <Text textStyle={"mediumXl"} alignSelf={"flex-end"}>
                        {text5}
                    </Text>
                </Flex>
            </Flex>
        </Flex>
    );
};
